import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MapPropTypes from '../../MapPropTypes';
import Label from './Label';

export default class Continuous extends Component {
    static propTypes = {
        maxMonths: PropTypes.number.isRequired,
        minMonths: PropTypes.number.isRequired,
        maxWeeks: PropTypes.number.isRequired,
        monthCount: PropTypes.number.isRequired,
        onBlur: PropTypes.func.isRequired,
        prices: MapPropTypes.PricingProps.isRequired,
        showWeeks: PropTypes.bool,
        updateMonthCount: PropTypes.func.isRequired,
        updateWeekCount: PropTypes.func,
        weekCount: PropTypes.number,
    };

    constructor(props) {
        super(props);
    }

    _renderMonthInput() {
        return (
            <div>
                <input
                    value={this.props.monthCount}
                    onChange={(e) =>
                        this.props.updateMonthCount(
                            parseInt(e.target.value, 10)
                        )
                    }
                    onBlur={() => this.props.onBlur()}
                    type="number"
                    className="form-control m-l-xs"
                    step="1"
                    min={this.props.showWeeks ? 0 : this.props.minMonths}
                    max={this.props.maxMonths}
                />
                <Label s="months" />
            </div>
        );
    }

    _renderWeekInput() {
        return (
            <div>
                <input
                    value={this.props.weekCount}
                    onChange={(e) =>
                        this.props.updateWeekCount(parseInt(e.target.value, 10))
                    }
                    onBlur={() => this.props.onBlur()}
                    type="number"
                    className="form-control m-l-xs"
                    step="1"
                    min="0"
                    max={this.props.maxWeeks}
                />
                <Label s="weeks" />
            </div>
        );
    }

    render() {
        return (
            <div className="row m-a-0">
                <div
                    className={
                        this.props.showWeeks ? 'col-xs-6 p-a-0' : 'col-xs-12'
                    }
                >
                    {this._renderMonthInput()}
                </div>
                {this.props.showWeeks && (
                    <div className="p-a-0 p-l-xs col-xs-6">
                        {this._renderWeekInput()}
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Cart/DurationInput/Continuous.jsx